/**
 * Count-up figures — any element carrying [data-countup] animates its number from
 * zero to the value already rendered on the server, once, when it first scrolls
 * into view.
 *
 * The server-rendered text is the source of truth: the script parses the first
 * run of digits out of it (so "$ 5 656", "15" and "7" all work, whatever the
 * shop's money format), animates that run, then restores the original string
 * character for character. Nothing to keep in sync with Liquid.
 *
 * Bails out entirely — leaving the final value on screen — when the visitor asks
 * for reduced motion or the browser has no IntersectionObserver.
 */
(function () {
  var DURATION = 900;

  function parse(el) {
    var text = el.textContent.trim();
    // First digit run, including whatever grouping character the money format uses
    // (\s covers plain space, NBSP and narrow NBSP in JS).
    var match = text.match(/\d[\d\s.,]*\d|\d/);
    if (!match) return null;

    var raw = match[0];
    var target = parseInt(raw.replace(/\D/g, ''), 10);
    if (!isFinite(target) || target < 1) return null;

    var separator = (raw.match(/[^\d]/) || [''])[0];
    return {
      el: el,
      target: target,
      separator: separator,
      prefix: text.slice(0, match.index),
      suffix: text.slice(match.index + raw.length),
      final: text,
    };
  }

  function group(value, separator) {
    var digits = String(value);
    if (!separator) return digits;
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function run(plan) {
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / DURATION, 1);
      // easeOutCubic — fast out of the gate, settles on the final number.
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(plan.target * eased);

      if (progress < 1) {
        plan.el.textContent = plan.prefix + group(value, plan.separator) + plan.suffix;
        window.requestAnimationFrame(frame);
      } else {
        plan.el.textContent = plan.final;
      }
    }

    window.requestAnimationFrame(frame);
  }

  function init() {
    var els = [].slice.call(document.querySelectorAll('[data-countup]'));
    if (!els.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window) || !window.requestAnimationFrame) return;

    var plans = {};
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          var plan = plans[entry.target.dataset.countupId];
          if (plan) run(plan);
        });
      },
      { threshold: 0.4 }
    );

    els.forEach(function (el, i) {
      var plan = parse(el);
      if (!plan) return;
      el.dataset.countupId = String(i);
      plans[i] = plan;
      // Hold the first frame so the figure does not flash its final value.
      el.textContent = plan.prefix + group(0, '') + plan.suffix;
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
